import styles from '../../styles/Birth.module.css';

export default function FormNavigation({
  step,
  setStep,
  isLoading,
  inputPress,
  variable = true,
  lastIncrement = 1,
  continueBtn = true,
  path,
  setPath,
}) {
  const decrement = async () => {
    // console.log(`--- Before Decrement -- Path: ${path}`);
    setStep(path[path.length - 2]);
    setPath((prevPath) => {
      return prevPath.slice(0, prevPath.length - 1);
    });
  };
  return (
    <div className={`${styles['bottom-nav']} red`}>
      {step !== 1 && (
        <button
          className={`${styles['bottom-btn-back2']} red`}
          onClick={decrement}
          disabled={isLoading}
        >
          <div className={`${styles['bottom-btn-back-container']} red`}>
            <Arrow />
            <div>Back</div>
          </div>
        </button>
      )}

      {continueBtn && (
        <button
          className={`${styles['bottom-btn-next2']} red`}
          onClick={inputPress}
          disabled={isLoading || !variable}
        >
          Continue
        </button>
      )}
    </div>
  );
}

// Arrow SVG
function Arrow() {
  return (
    <svg
      className={`${styles['arrow-back']} red`}
      fill="none"
      stroke="#000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      ></path>
    </svg>
  );
}
